import Cite from "../../../../src/components/cite";
import TeX from "../../../../src/components/tex";
import Proof from "../../../../src/components/proof";
import * as React from 'react';
export default {
  Cite,
  TeX,
  Proof,
  React
};